import { UserPlus, ClipboardCheck, Calendar } from "lucide-react";
import { useTranslation } from "react-i18next";

export function HowItWorks() {
  const { t } = useTranslation(["landing"]);

  const steps = [
    {
      icon: <UserPlus size={36} className="text-primary" />,
      title: t("landing:how_it_works_patient.steps.title_1"),
      description: t("landing:how_it_works_patient.steps.desc_1"),
    },
    {
      icon: <ClipboardCheck size={36} className="text-primary" />,
      title: t("landing:how_it_works_patient.steps.title_2"),
      description: t("landing:how_it_works_patient.steps.desc_2"),
    },
    {
      icon: <Calendar size={36} className="text-primary" />,
      title: t("landing:how_it_works_patient.steps.title_3"),
      description: t("landing:how_it_works_patient.steps.desc_3"),
    },
  ];
  

  return (
    <section
      id="how-it-works"
      className="bg-primary/5 border-y border-primary/10 py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
        <h2 className="text-3xl font-bold">
          {t("landing:how_it_works_patient.title")}
        </h2>
        <p className="text-foreground/80 mt-4 max-w-2xl mx-auto">
        {t("landing:how_it_works_patient.sub_title")}
        </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10 mt-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="
              flex flex-col items-center text-center
              bg-card 
              text-card-foreground
              p-10 rounded-xl 
              shadow-sm 
              border border-border 
              hover:shadow-md 
              transition
            "
            >
              <div className="mb-6">{step.icon}</div>

              <h3 className="text-xl font-semibold">
                {step.title}
              </h3>

              <p className="mt-2 text-foreground/70">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
